import { supabase } from "@/services/supabase/createClient";
import * as Sentry from "@sentry/react";

type RemoveFolderResponse = {
  success: boolean;
  error?: string;
};

export const removeFolderInStorage = async (bucketName: string, folderPath: string): Promise<RemoveFolderResponse> => {
  try {
    const { data: files, error: listError } = await supabase.storage.from(bucketName).list(folderPath);

    if (listError) {
      throw new Error(`Error listing files: ${listError.message}`);
    }

    if (!files || files.length === 0) {
      return { success: true };
    }

    const filePathsToRemove = files.filter((file) => file.name).map((file) => `${folderPath}/${file.name}`);

    const { error: removeError } = await supabase.storage.from(bucketName).remove(filePathsToRemove);

    if (removeError) {
      throw new Error(`Error removing files: ${removeError.message}`);
    }

    return { success: true };
  } catch (error: any) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
};
